import { render } from "./SettingBlock.vue?vue&type=template&id=57cc4eee&scoped=true&ts=true"
import script from "./SettingBlock.vue?vue&type=script&lang=ts"
export * from "./SettingBlock.vue?vue&type=script&lang=ts"

import "./SettingBlock.vue?vue&type=style&index=0&id=57cc4eee&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cc4eee"]])

export default __exports__